'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _from = require('babel-runtime/core-js/array/from');

var _from2 = _interopRequireDefault(_from);

var _each2 = require('lodash/each');

var _each3 = _interopRequireDefault(_each2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

cbStripActualiteitenV1.$inject = ['ApiService'];


var _ = {
    each: _each3.default
};

var _module = angular.module('cb.strips.cbStripActualiteitenV1', []);

_module.directive('cbStripActualiteitenV1', cbStripActualiteitenV1);

exports.default = _module;


function cbStripActualiteitenV1(ApiService) {
    return {
        restrict: 'A',
        link: cbStripActualiteitenV1Link
    };

    function addActualiteitenHeadingCbFunctions(element) {
        var _gettersAndSetters = addActualiteitenHeadingGettersAndSetters(element);
        var gettersAndSetters = ApiService.registerGettersAndSetters(_gettersAndSetters);

        ApiService.attach({
            'actualiteiten-heading': gettersAndSetters
        });
    }

    function cbStripActualiteitenV1Link(scope, element, attr) {
        addActualiteitenHeadingCbFunctions(element);

        _.each(element.find('.content-block'), function (contentBlockElement) {
            contentBlockElement = angular.element(contentBlockElement);
            var _gettersAndSetters = addActualiteitenCardGettersAndSetters(contentBlockElement);
            var gettersAndSetters = ApiService.registerGettersAndSetters(_gettersAndSetters);

            ApiService.attach({
                'actualiteiten-card': gettersAndSetters
            });
        });
    }

    function addActualiteitenHeadingGettersAndSetters(element) {
        var actualiteiten = {};

        Object.defineProperty(actualiteiten, 'title', {
            get: function get() {
                return element.find('.heading-strip-title').html();
            },
            set: function set(newValue) {
                element.find('.heading-strip-title').html(newValue);
            }
        });

        Object.defineProperty(actualiteiten, 'subtitle', {
            get: function get() {
                return angular.element(element.find('.heading-strip-subtitle')[0]).html();
            },
            set: function set(newValue) {
                angular.element(element.find('.heading-strip-subtitle')[0]).html(newValue);
            }
        });

        return actualiteiten;
    }
}

function addActualiteitenCardGettersAndSetters(element) {
    var card = {};

    Object.defineProperty(card, 'imageDefault', {
        get: function get() {
            return element.find('.content-block__image-img').attr('src');
        },
        set: function set(newValue) {
            element.find('.content-block__image-img').attr('src', newValue);
        }
    });

    Object.defineProperty(card, 'imageSmall', {
        get: function get() {
            return $(element.find('picture source')[2]).attr('srcset');
        },
        set: function set(newValue) {
            $(element.find('picture source')[2]).attr('srcset', newValue);
        }
    });

    Object.defineProperty(card, 'imageMedium', {
        get: function get() {
            return $(element.find('picture source')[1]).attr('srcset');
        },
        set: function set(newValue) {
            $(element.find('picture source')[1]).attr('srcset', newValue);
        }
    });

    Object.defineProperty(card, 'imageLarge', {
        get: function get() {
            return $(element.find('picture source')[0]).attr('srcset');
        },
        set: function set(newValue) {
            $(element.find('picture source')[0]).attr('srcset', newValue);
        }
    });

    Object.defineProperty(card, 'imageAlt', {
        get: function get() {
            return element.find('.content-block__image-img').attr('alt');
        },
        set: function set(newValue) {
            element.find('.content-block__image-img').attr('alt', newValue);
        }
    });

    Object.defineProperty(card, 'title', {
        get: function get() {
            return angular.element(element.find('.heading-strip-subtitle')[0]).html();
        },
        set: function set(newValue) {
            angular.element(element.find('.heading-strip-subtitle')[0]).html(newValue);
        }
    });

    Object.defineProperty(card, 'text', {
        get: function get() {
            return element.find('.text').html();
        },
        set: function set(newValue) {
            element.find('.text').html(newValue);
        }
    });

    Object.defineProperty(card, 'link', {
        get: function get() {
            return element.attr('href');
        },
        set: function set(newValue) {
            element.attr('href', newValue);
        }
    });

    Object.defineProperty(card, 'theme', {
        get: function get() {
            return (0, _from2.default)(element[0].classList).find(function (className) {
                return className.indexOf('t-content-block--') === 0;
            }).replace(/^t-content-block--/, '');
        },
        set: function set(newValue) {
            var colors = ['border-groen', 'mais', 'border-cappuccino', 'fuchsia', 'blauw'];
            if (!colors.includes(newValue)) {
                throw new Error('Invalid color \'' + newValue + '\'; valid colors are: ' + colors);
            }

            // Remove green title class if it exists
            var title = element.find('.heading-strip-subtitle')[0].classList;
            if (title.contains('u-text-green')) {
                title.remove('u-text-green');
            }

            // Remove all classes starting with t-content-block--
            (0, _from2.default)(element[0].classList).filter(function (className) {
                return className.indexOf('t-content-block--') === 0;
            }).forEach(function (className) {
                element.removeClass(className);
            });

            element.addClass('t-content-block--' + newValue);
        }
    });

    Object.defineProperty(card, 'spotTitle', {
        get: function get() {
            return element.find('.spot__price').html();
        },
        set: function set(newValue) {
            element.find('.spot__price').html(newValue);
        }
    });

    Object.defineProperty(card, 'spotText', {
        get: function get() {
            return element.find('.u-text-small').html();
        },
        set: function set(newValue) {
            element.find('.u-text-small').html(newValue);
        }
    });

    Object.defineProperty(card, 'display', {
        get: function get() {
            return element.css('display');
        },
        set: function set(newValue) {
            element.css('display', newValue);
        }
    });

    return card;
}


//////////////////
// WEBPACK FOOTER
// ./src/strips/actualiteiten-v1/actualiteiten.directive.js
// module id = 932
// module chunks = 1